import './index.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import * as OffcanvasMenu from '../assets-base/assets-src/js/Spinao/OffcanvasMenu';
//import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import '../assets-base/assets-src/js/Bootstrap/dropdown';
import '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/alert';
//import '../assets-base/assets-src/js/Bootstrap/button';
import '../assets-base/assets-src/js/Bootstrap/carousel';
import '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/modal';
//import '../assets-base/assets-src/js/Bootstrap/offcanvas';
//import '../assets-base/assets-src/js/Bootstrap/popover';
//import '../assets-base/assets-src/js/Bootstrap/scrollspy';
import '../assets-base/assets-src/js/Bootstrap/tab';
import '../assets-base/assets-src/js/Spinao/TabWithHistory';
//import '../assets-base/assets-src/js/Bootstrap/toast';
//import '../assets-base/assets-src/js/Bootstrap/tooltip';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as NetteAjaxLink from '../assets-base/assets-src/js/Spinao/NetteAjaxLink';
import * as EndlessList from '../assets-base/assets-src/js/Spinao/EndlessList';
import * as PlusMinusBtn from '../assets-base/assets-src/js/Spinao/PlusMinusBtn';
import * as RadioLikeCheckboxes from '../assets-base/assets-src/js/Spinao/RadioLikeCheckboxes';
import * as CheckboxCombinations from '../assets-base/assets-src/js/Spinao/CheckboxCombinations';
import * as FormPersister from '../assets-base/assets-src/js/Spinao/FormPersister';
import * as DatePicker from '../assets-base/assets-src/js/Spinao/DatePicker';
import * as AnimatedAnchor from '../assets-base/assets-src/js/Spinao/AnimatedAnchors';
import * as AttributeSetter from '../assets-base/assets-src/js/Spinao/AttributeSetter';
import * as Ares from '../assets-base/assets-src/js/Spinao/Ares';
import '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import '../assets-base/assets-src/js/Spinao/Basket';
import '../assets-base/assets-src/js/Spinao/DelegateClick';
import "../assets-base/assets-src/js/Spinao/CookieConsent";
import '../assets-base/assets-src/js/Spinao/Masonry';

document.addEventListener("DOMContentLoaded", function() {
    Lightgallery.applyTo('[data-lightgallery="area"]', {
        selector:'[data-lightgallery="image"]',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    AnimatedAnchor.run();
    CheckboxCombinations.initialize();
    RadioLikeCheckboxes.initialize();
    PlusMinusBtn.initialize();
    FormPersister.initialize();

    OffcanvasMenu.initialize();
    //StickyTopMenu.initialize();

    NetteAjaxForm.initialize('form[data-ajax]');
    NetteAjaxLink.applyTo('a[data-ajax]');

    GoogleMaps.initialize();

    UnifyHeight.applyDataAttribute();
    EndlessList.applyTo('[data-endless-list]');
    DatePicker.initialize();
    AttributeSetter.run();
    Ares.run();
});
